
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UserPointsSummary {
  user_id: string;
  email: string;
  name: string;
  country_code: string;
  total_points: number;
  lifetime_earned: number;
  last_transaction_at: string | null;
  suspicious_activity: boolean;
}

export const useUserPointsSummary = (
  searchEmail?: string,
  countryFilter?: string,
  limit = 50,
  offset = 0
) => {
  const [data, setData] = useState<UserPointsSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUserPointsSummary = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const { data: result, error } = await supabase.rpc('get_user_points_summary', {
        search_email: searchEmail || null,
        country_filter: countryFilter || null,
        limit_param: limit,
        offset_param: offset
      });

      if (error) throw error;
      setData(result || []);
    } catch (err) {
      console.error('Error fetching user points summary:', err);
      setError('Failed to fetch user points data');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserPointsSummary();
  }, [searchEmail, countryFilter, limit, offset]);

  const refetch = () => {
    fetchUserPointsSummary();
  };

  return {
    data,
    isLoading,
    error,
    refetch
  };
};
